export enum Environnement {
  Development = "development",
  Test = "test",
  Production = "production",
}
